import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-tourpackage-list',
  templateUrl: './tourpackage-list.component.html',
  styleUrls: ['./tourpackage-list.component.sass']
})
export class TourpackageListComponent implements OnInit {
  logoImage: string = "./assets/img/no-logo.png"
  coverImage: string = "./assets/img/cover-ads.png"
  
  //tourpackageDocId;
  tourpackageCol;
  
  constructor(    
    private route: Router,
    private aroute: ActivatedRoute,
    public db: FirestoreService
  ) { }

  ngOnInit(): void {
    this.tourpackageCol = this.db.getMainCol('tourpackages');
  };

  routeTourPackageDetailPage(docId){
    this.route.navigateByUrl('tourpackage/'+docId);
  }

}